import * as trackingHelpers from '../tracking/utils/helpers';
import {
  LS_BI_TRACKING_CID,
  LS_BI_TRACKING_LANDINGPAGEREFERRER,
  LS_BI_TRACKING_REFERRER,
  LS_CARE_LEVEL_CALCULATOR_JWT,
} from '@/constants/storage';

import Vue from 'vue';
import { ROUTE_TRACKING_UNREGISTERED_USER } from '@/constants/apiRoutes';
import store from '@/store';

const pgrVersion = window.config?.PGR_VERSION ? window.config.PGR_VERSION : '1.0.0';

export function getBiTrackingData(status = '', jwt = '') {
  const { trackingUuid } = store.getters;
  return {
    trackingStatus: status,
    url: trackingHelpers.getPageUrl(),
    referrer: localStorage.getItem(LS_BI_TRACKING_REFERRER),
    cid: localStorage.getItem(LS_BI_TRACKING_CID),
    jwt: jwt,
    wizardVersion: pgrVersion,
    testVariante: '',
    landingPageReferrer: localStorage.getItem(LS_BI_TRACKING_LANDINGPAGEREFERRER),
    uuid: trackingUuid,
  };
}

export function trackBIUnregisteredUser(status = '', route = ROUTE_TRACKING_UNREGISTERED_USER) {
  const unregisteredUserToken = localStorage.getItem(LS_CARE_LEVEL_CALCULATOR_JWT) || null;
  if (unregisteredUserToken) {
    Vue.axios.post(route, {
      trackingRequest: getBiTrackingData(status, unregisteredUserToken),
    });
  }
}
